import { Fragment } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ToastProvider } from "barte-design-system";
import "barte-design-system/styles";
import { PostHogProvider } from "@posthog/react";

import { ROUTES_PAYFAC } from "@payfac/constants";
import { enviroment } from "@shared/constants";
import i18nPayfac from "@/modules/shared/configs/i18n/i18n";
import { queryClientPayfac } from "@/modules/shared/configs/query/query-client";

import { PostHogIdentify, DevTools } from "./components";

import favicon from "../../assets/favicon.avif";

import type { RootLayoutProps } from './root-layout.type'

const postHogOptions = {
    api_host: enviroment.PUBLIC_POSTHOG_HOST,
    defaults: "2026-01-30",
} as const;

export function RootLayout({ children }: RootLayoutProps) {
    const { pathname } = useLocation();

    const pathsWithPostHog = [ROUTES_PAYFAC.path];

    const hasPostHog = pathsWithPostHog.some((path) => pathname.includes(path)) && !!enviroment.PUBLIC_POSTHOG_KEY;

    const content = (
        <ToastProvider position="top-right">
            <I18nextProvider i18n={i18nPayfac}>
                <Helmet>
                    <link rel="icon" href={favicon} />
                </Helmet>

                <QueryClientProvider client={queryClientPayfac}>
                    {children}
                    <DevTools />
                    <ReactQueryDevtools initialIsOpen={false} />
                </QueryClientProvider>
            </I18nextProvider>
        </ToastProvider>
    );

    if (hasPostHog) {
        return (
            <PostHogProvider
                apiKey={enviroment.PUBLIC_POSTHOG_KEY!}
                options={postHogOptions}
            >
                <PostHogIdentify />
                {content}
            </PostHogProvider>
        );
    }

    return content;
}
